<p-button [icon]="icon" [loading]="loading"
pTooltip={{tooltipText}}
tooltipPosition='top'
[disabled]="disabled" [style]="buttonStyle" 
(click)="onClick($event)" class="custom-button">{{buttonText}}</p-button>
